import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import {
  FinishJobAssemblySessionRequest,
  IJobAssemblySessionResponse,
  PauseJobAssemblySessionRequest,
  StartJobAssemblySessionRequest
} from "../models/Job";

export default function useJobAssemblySession(jobId?: string) {
  const { get, post } = useApiHelper();
  const queryClient = useQueryClient();

  const sessions = useQuery({
    queryKey: ["jobAssemblySessions", jobId],
    queryFn: () => get<IJobAssemblySessionResponse>(`/JobAssemblySession/job/${jobId}`),
    enabled: !!jobId,
  });

  const invalidate = () => {
    queryClient.invalidateQueries(["jobAssemblySessions", jobId]);
    queryClient.invalidateQueries(["job", jobId]);
    queryClient.invalidateQueries(["jobs"]);
  };

  const startSession = useMutation(
    (body: StartJobAssemblySessionRequest) => post("/JobAssemblySession/start", body),
    {
      onSuccess: () => {
        invalidate();
      }
    }
  );

  const pauseSession = useMutation(
    (body: PauseJobAssemblySessionRequest) => post("/JobAssemblySession/pause", body),
    {
      onSuccess: () => {
        invalidate();
      }
    }
  );

  const finishSession = useMutation(
    (body: FinishJobAssemblySessionRequest) => post("/JobAssemblySession/finish", body),
    {
      onSuccess: () => {
        invalidate();
      }
    }
  );

  return {
    sessions,
    startSession,
    pauseSession,
    finishSession
  };
}
